interface GenerateWrapParams {
  width: number;
  height: number;
  padding: number;
}

export function generateWrap({ width, height, padding }: GenerateWrapParams): string {
  const svg = `<svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg">
    <rect x="0" y="0" width="${width}" height="${height}" fill="none" stroke="red" stroke-width="${padding}" />
    <text x="${padding / 2}" y="${height / 2}" text-anchor="middle" dominant-baseline="middle"
          font-size="${padding / 3}" fill="white"
          transform="rotate(-90, ${padding / 4}, ${height / 2})">Folded edge</text>
    <text x="${width - padding / 4}" y="${height / 2}" text-anchor="middle" dominant-baseline="middle"
          font-size="${padding / 3}" fill="white"
          transform="rotate(90, ${width - padding / 4}, ${height / 2})">Folded edge</text>
  </svg>`;
  return `data:image/svg+xml;base64,${btoa(svg)}`;
}
